import { type AuthTokens, serializeAuthCookies } from '@nutralab/api';

import { AUTH_COOKIE_DOMAIN, LEGACY_AUTH_TOKENS_STORAGE_KEY } from '@/shared/constants';

/** Saves the session tokens in the cookies shared with the personal account, or ends the session with `null`. */
export function persistAuthTokens(tokens: AuthTokens | null): void {
    // A host-only cookie from before the shared domain would shadow the shared one: expire it first.
    if (AUTH_COOKIE_DOMAIN) {
        serializeAuthCookies(null).forEach((cookie) => (document.cookie = cookie));
    }
    serializeAuthCookies(tokens, {
        domain: AUTH_COOKIE_DOMAIN,
        isSecure: window.location.protocol === 'https:',
    }).forEach((cookie) => (document.cookie = cookie));

    try {
        localStorage.removeItem(LEGACY_AUTH_TOKENS_STORAGE_KEY);
    } catch {
        // localStorage unavailable: nothing to clean up.
    }
}
